import * as constants from '../actions/constants';

const initialState = {
    photosCount: {value: 0},
    photos: {
        available: false,
        error: null,
        data: [],
    },

    dashboard: {},
};

// Check if there is any existing dashboard data in session
if (sessionStorage.getItem('user_data')) {
    const session_data = JSON.parse(sessionStorage.getItem('user_data'));
    initialState.dashboard = {...session_data};
}

export const userReducer = (state = initialState, action) => {
    if (action.type === constants.user.UPDATE_DASHBOARD) {
        let newState = {...state};
        newState.dashboard = action.payload;
        return newState;
    }

    if (action.type === constants.user.REMOVE_DASHBOARD) {
        let newState = {...state};
        newState.dashboard = {};
        return newState;
    }

    if (action.type === constants.user.GET_PHOTOS_COUNT) {
        let newState = {...state};
        newState.photosCount = {value: action.payload};
        return newState;
    }

    if (action.type === constants.user.GET_PHOTOS) {
        let newState = {...state};
        newState.photos.available = false;
        newState.photos.data = [];
        newState.photos.error = null;
        
        return newState;
    }

    if (action.type === constants.user.GET_PHOTOS_SUCCESS) {
        let newState = {...state};
        newState.photos.available = true;
        newState.photos.data = action.payload;
        newState.photos.error = null;

        return newState;
    }

    if (action.type === constants.user.GET_PHOTOS_FAILED) {
        let newState = {...state};
        newState.photos.available = false;
        newState.photos.data = [];
        newState.photos.error = action.payload;
        
        return newState;
    }

    return state;
};